module.exports = __webpack_public_path__ + "assets/img/j-bar-tube.c926eb2b.png";